import React, { useState, useEffect, useRef } from 'react';
import './CompetitiveAdvantages.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faClock, faCheckCircle, faShieldAlt, faGlobe, faLifeRing } from '@fortawesome/free-solid-svg-icons';

const CompetitiveAdvantages = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className="competitive-advantages" ref={sectionRef}>
      <h2 className="section-title">Por Qué Elegir Punto Central</h2>
      <div className="advantages-container">
        <div className={`advantage-card ${isVisible ? 'animate__animated animate__fadeInUp' : ''}`}>
          <FontAwesomeIcon icon={faRocket} className="advantage-icon" />
          <h3>Rápido y Eficiente</h3>
          <p>Implementa soluciones que aceleran tu operación, reducen tiempos de gestión y optimizan cada aspecto de tu negocio.</p>
        </div>
        <div className={`advantage-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}`}>
          <FontAwesomeIcon icon={faClock} className="advantage-icon" />
          <h3>Disponible 24/7</h3>
          <p>Accede a tu sistema en cualquier momento y desde cualquier lugar con conexión a internet, sin limitaciones de horario.</p>
        </div>
        <div className={`advantage-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-2s' : ''}`}>
          <FontAwesomeIcon icon={faCheckCircle} className="advantage-icon" />
          <h3>Confiable y Probado</h3>
          <p>Utilizado por cientos de clientes en diferentes sectores comerciales con resultados comprobados y satisfacción garantizada.</p>
        </div>
        <div className={`advantage-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-3s' : ''}`}>
          <FontAwesomeIcon icon={faShieldAlt} className="advantage-icon" />
          <h3>Seguridad de Datos</h3>
          <p>Tus datos están protegidos con encriptación de nivel empresarial y respaldos automáticos en servidores seguros de Firebase.</p>
        </div>
        <div className={`advantage-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-4s' : ''}`}>
          <FontAwesomeIcon icon={faGlobe} className="advantage-icon" />
          <h3>Escalable en la Nube</h3>
          <p>Crece sin preocupaciones. La infraestructura se adapta automáticamente a tus necesidades sin requieren configuración adicional.</p>
        </div>
        <div className={`advantage-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-5s' : ''}`}>
          <FontAwesomeIcon icon={faLifeRing} className="advantage-icon" />
          <h3>Soporte Dedicado</h3>
          <p>Contamos con soporte técnico personalizado para resolver tus consultas y asegurar que aproveches al máximo todas las funcionalidades.</p>
        </div>
      </div>
    </div>
  );
};

export default CompetitiveAdvantages;
